import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useAgentsAssistance(): RootState['agentsAssistance'] {
    const agentsAssistance = useSelector<RootState, RootState['agentsAssistance']>(
        ({ agentsAssistance }) => agentsAssistance
    );
    return agentsAssistance;
}
